export type QueryComparisonTableSettingsType = {
  customWidgetTitle: string;
  density: string;
  // displayAllQueriesRow?: boolean;
  rowStripes?: boolean;
  widgetTitle: string;
  widgetTitleAlignment: string;
};

export const queryComparisonTableDefaultSettings: QueryComparisonTableSettingsType = {
  customWidgetTitle: "",
  density: "standard",
  // displayAllQueriesRow: false,
  rowStripes: false,
  widgetTitle: "none",
  widgetTitleAlignment: "left",
};